import { DeactivateUserModalSteps } from "./types";

export const DEACTIVATE_USER_MODAL_DESCRIPTION: Record<
  DeactivateUserModalSteps,
  string
> = {
  reassignDirectReports: "Reassign direct reports",
  reassignTeamLeaders: "Handle manual team leadership",
  reassignDepartmentLeaders: "Department leadership",
  reviewChanges: "Review changes",
  responsibilitiesSummary: "", // This step will not have a description
};
